import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { NoLoginChatBanner } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function NoLoginChat() {
  return (
    <>
      <SEO
        title="Random Video Chat No Login - Instant & Free | Talkvee"
        description="Start video chatting with strangers instantly. No registration, no login, and no credit card required. Just click and match on Talkvee."
        pathname="/stranger-chat-no-login"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "No Login Chat", "item": "https://talkvee.com/stranger-chat-no-login" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <NoLoginChatBanner />
        
        <section className="landing-hero">
          <h1 className="landing-title">Instant Random Chat — No Login Required</h1>
          <p className="landing-subtitle">
            Why wait? Most apps make you fill out forms before you can even see a face. On Talkvee, we value your time. Use our guest login to start meeting people from around the world in under 5 seconds.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting Instantly</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Instant Access Features</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#f0fdf4', padding: '20px', borderRadius: '12px', border: '1px solid #bbf7d0'}}>
              <h4 style={{margin: '0 0 10px', color: '#166534', fontSize: '1.1rem'}}>🔓 Guest Entry</h4>
              <p style={{margin: 0, color: '#14532d', lineHeight: '1.6'}}>
                No email or phone number needed. Your temporary guest profile lets you chat immediately.
              </p>
            </div>
            <div style={{background: '#f0fdf4', padding: '20px', borderRadius: '12px', border: '1px solid #bbf7d0'}}>
              <h4 style={{margin: '0 0 10px', color: '#166534', fontSize: '1.1rem'}}>💨 Zero Friction</h4>
              <p style={{margin: 0, color: '#14532d', lineHeight: '1.6'}}>
                Optimized for speed. No "Welcome" tutorials or mandatory profile pictures. Just click and match.
              </p>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "Can I really chat without a login?",
              a: "Yes! Talkvee allows you to join as a guest. You only need to create an account if you want to save your global ranking points or VeeClips."
            },
            {
              q: "Is it safe to chat without an account?",
              a: "Absolutely. Our AI moderation and reporting tools apply to everyone, whether you are a guest or a registered user."
            },
            {
              q: "Can I switch from guest to a real account later?",
              a: "Yes! You can link your guest session to a Google or Facebook account at any time in the settings to keep your progress."
            }
          ]}
        />
      </div>
    </>
  );
}